module.exports = __webpack_public_path__ + "img/scene_2.dd9bdd4d.png";